import { defineCustomElement } from "vue";
import VCCheckbox from "./VCCheckbox.ce.vue";
import { Register } from "..";

const tag = "vc-checkbox";

const _register: Register = {
  register() {
    customElements.get(tag) ||
      customElements.define(tag, defineCustomElement(VCCheckbox));
  }
};

export default _register;
